import tagTester from './_tagTester.js';

export default tagTester('Error');



//////////////////
// WEBPACK FOOTER
// ./~/backbone/~/underscore/modules/isError.js
// module id = 489
// module chunks = 7